/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationPartnerUpdateRequest model module.
 * @module model/EventsControllerDtoEventInvitationPartnerUpdateRequest
 * @version 1.0
 */
class EventsControllerDtoEventInvitationPartnerUpdateRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationPartnerUpdateRequest</code>.
     * @alias module:model/EventsControllerDtoEventInvitationPartnerUpdateRequest
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationPartnerUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationPartnerUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerUpdateRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationPartnerUpdateRequest} The populated <code>EventsControllerDtoEventInvitationPartnerUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationPartnerUpdateRequest();

            if (data.hasOwnProperty('partnerAccountNo')) {
                obj['partnerAccountNo'] = ApiClient.convertToType(data['partnerAccountNo'], 'Number');
            }
            if (data.hasOwnProperty('invCode')) {
                obj['invCode'] = ApiClient.convertToType(data['invCode'], 'String');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationPartnerUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationPartnerUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['invCode'] && !(typeof data['invCode'] === 'string' || data['invCode'] instanceof String)) {
            throw new Error("Expected the field `invCode` to be a primitive type in the JSON string but got " + data['invCode']);
        }

        return true;
    }


}



/**
 * @member {Number} partnerAccountNo
 */
EventsControllerDtoEventInvitationPartnerUpdateRequest.prototype['partnerAccountNo'] = undefined;

/**
 * @member {String} invCode
 */
EventsControllerDtoEventInvitationPartnerUpdateRequest.prototype['invCode'] = undefined;

/**
 * @member {Boolean} enabled
 */
EventsControllerDtoEventInvitationPartnerUpdateRequest.prototype['enabled'] = undefined;






export default EventsControllerDtoEventInvitationPartnerUpdateRequest;

